import VideoConatiner from "./VideoConatiner";

const BodyMainConatiner = () => {
  return <VideoConatiner />;
};

export default BodyMainConatiner;
